import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  HStack,
  Text,
  List,
  ListItem,
  ListIcon,
  Alert,
  AlertIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

import type { AvailableCarrier } from 'api/quote-marketplace';

interface RfqConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCarriers: AvailableCarrier[];
  isLoading?: boolean;
  hasSelectedCarrier?: boolean;
}

const RfqConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCarriers,
  isLoading = false,
  hasSelectedCarrier = false,
}: RfqConfirmationModalProps) => {
  const listBg = useColorModeValue('gray.50', 'whiteAlpha.50');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Quote Request</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            {hasSelectedCarrier && (
              <Alert status="warning" borderRadius="md">
                <AlertIcon />
                <Text fontSize="sm">
                  Quoting will clear your current carrier selection and all
                  existing quote results.
                </Text>
              </Alert>
            )}

            <Text>
              You are about to request quotes from the following{' '}
              {selectedCarriers.length} market
              {selectedCarriers.length !== 1 ? 's' : ''}:
            </Text>
            <List
              spacing={2}
              bg={listBg}
              p={4}
              borderRadius="md"
              maxH="200px"
              overflowY="auto"
            >
              {selectedCarriers.map((carrier) => (
                <ListItem key={`${carrier.carrier_id}-${carrier.product}`}>
                  <HStack>
                    <ListIcon as={CheckCircleIcon} color="green.500" />
                    <Text>{carrier.display_name}</Text>
                  </HStack>
                </ListItem>
              ))}
            </List>

            <Text fontSize="sm" color="gray.500">
              Click "Get Quotes" to submit the request to these carriers.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            colorScheme="yellow"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            Get Quotes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RfqConfirmationModal;
